module.exports = __webpack_public_path__ + "static/img/bigNotes.b8efa224.png";